import { useState } from 'react';
import styles from './AddCreditBalance.module.css';
import { useDispatch } from 'react-redux';
import { closeModal } from '../../../redux/slices/modalSlice';

import HeadingAndData from '../../../components/HeadingAndData/HeadingAndData';
import HeadingAndDropDown from '../../../components/HeadingAndDropDown/HeadingAndDropDown';
import SaveAndCancel from '../../../components/SaveAndCancel/SaveAndCancel';
import ToClose from '../../../components/ToClose/ToClose';
import HeadingAndIcon from '../../../components/HeadingAndIcon/HeadingAndIcon';
import CheckboxAndData from '../../../components/CheckboxAndData/CheckboxAndData';
import CalendarInput from '../../../components/CalendarInput/CalendarInput';
import { IoDocumentTextOutline } from 'react-icons/io5';

const AddCreditBalance = () => {
  const dispatch = useDispatch();

  const [form, setForm] = useState({
    amount: '',
    date: '',
    approvedBy: '',
    reason: '',
    sendToParent: false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = () => {
    dispatch(closeModal());
  };

  const handleCancel = () => dispatch(closeModal());

  const handleCheckbox = (e) => {
    setForm((prev) => ({ ...prev, sendToParent: e.target.checked }));
  };

  return (
    <div className={styles.modalWrapper}>
      <div className={styles.totaldata}>
        <div className={styles.subheading}>
          <HeadingAndIcon
            icon={<IoDocumentTextOutline />}
            heading="Add Credit Balance"
            color="var(--Primary_Color)"
          />
          <ToClose onClose={() => dispatch(closeModal())} />
        </div>

        <div className={styles.content}>
          <div className={styles.formGrid}>
            <HeadingAndData
              label="Credit"
              name="amount"
              placeholder="Enter Credit amount"
              value={form.amount}
              onChange={handleChange}
              required
            />

            <CalendarInput
              fieldLabel="Date"
              required
              value={form.date}
              onChange={(date) => setForm((prev) => ({ ...prev, date }))}
            />
          </div>

          <div className={styles.reasonWrapper}>
            <HeadingAndDropDown
              label="Approved by"
              name="approvedBy"
              value={form.approvedBy}
              onChange={handleChange}
              options={[
                { label: 'Staff A', value: 'staffA' },
                { label: 'Staff B', value: 'staffB' },
              ]}
            />
          </div>
          <div className={styles.reasonWrapper}>
            <label className={styles.reasonLabel} htmlFor="reason">
              Reason
            </label>
            <textarea
              id="reason"
              name="reason"
              placeholder="Enter reason here"
              className={styles.textareaField}
              value={form.reason}
              onChange={handleChange}
            />
          </div>
          <div className={styles.bottomWrapper}>
            <CheckboxAndData
              label="Send Details to parent"
              checked={form.sendToParent}
              onChange={handleCheckbox}
              labelColor="var(--Grey_Color)"
              checkboxSize={14}
            />
          </div>
          <div className={styles.bottomMessageWrapper}>
            Amount will be added to balance of the selected student
          </div>

          <div className={styles.bottomRow}>
            <SaveAndCancel
              onSave={handleSave}
              onCancel={handleCancel}
              saveLabel="Submit"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddCreditBalance;
